/** @jsx h */
import { labels } from '../config';
import TeaserGeneral from '../components/TeaserGeneral';
import TeaserArticle from '../components/TeaserArticle';
import TeaserChallenges from '../components/TeaserChallenges';
import TeaserCourses from '../components/TeaserCourses';

const ResultContainer = ({
  searchType,
  allResultCount,
  list,
  pagination,
  loadMore,
  pluginNamespace,
  sorting,
  triggerAjaxSubmit,
}) => {
  switch (searchType) {
    case 'global':
    case 'jobs':
    case 'press':
      return (
        <TeaserGeneral
          allResultCount={allResultCount}
          list={list}
          pagination={pagination}
          loadMore={loadMore}
          pluginNamespace={pluginNamespace}
        />
      );
    case 'news':
    case 'article':
      return (
        <TeaserArticle
          allResultCount={allResultCount}
          list={list}
          pagination={pagination}
          loadMore={loadMore}
          pluginNamespace={pluginNamespace}
        />
      );
    case 'challenges':
      return (
        <TeaserChallenges
          allResultCount={allResultCount}
          list={list}
          pagination={pagination}
          loadMore={loadMore}
          pluginNamespace={pluginNamespace}
        />
      );
    case 'courses':
      return (
        <TeaserCourses
          allResultCount={allResultCount}
          list={list}
          pagination={pagination}
          loadMore={loadMore}
          pluginNamespace={pluginNamespace}
          sorting={sorting}
          triggerAjaxSubmit={triggerAjaxSubmit}
        />
      );
    default:
      return labels.search.unavailable;
  }
};

export default ResultContainer;
